import { VStack, FormControl, Link } from "@chakra-ui/react"
import {
  FormLabel,
  FormErrorMessage,
  Input,
} from "@opengovsg/design-system-react"
import { useFormContext, useFormState } from "react-hook-form"
import { BiInfoCircle } from "react-icons/bi"

import { ANALYTICS_SETUP_LINK } from "constants/config"

import { Section, SectionHeader, SectionCaption } from "layouts/components"

interface AnalyticsSettingsProp {
  isError: boolean
}

export const AnalyticsSettings = ({
  isError,
}: AnalyticsSettingsProp): JSX.Element => {
  const { register } = useFormContext()
  const { errors } = useFormState()
  const isInvalid = (field: string) => !!errors[field]
  return (
    <Section id="analytics-fields">
      <VStack align="flex-start" spacing="0.5rem">
        <SectionHeader label="Analytics" />
        <SectionCaption icon={BiInfoCircle}>
          For Analytics set up, refer to our guide{" "}
          <Link href={ANALYTICS_SETUP_LINK} isExternal>
            here
          </Link>
        </SectionCaption>
      </VStack>
      <VStack spacing="1.5rem" align="flex-start" w="50%">
        <FormControl isDisabled={isError} isInvalid={isInvalid("pixel")}>
          <FormLabel>Facebook Pixel</FormLabel>
          <Input
            w="100%"
            {...register("pixel", {
              pattern: {
                value: /^[0-9]{15,16}$/,
                message:
                  "Your Facebook Pixel id should be a 15 or 16 digit number.",
              },
            })}
          />
          <FormErrorMessage>
            {/* NOTE: See here: https://github.com/opengovsg/design-system/issues/440
             * for why this is required
             */}
            {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
            {/* @ts-ignore */}
            {errors.pixel && errors.pixel.message}
          </FormErrorMessage>
        </FormControl>

        <FormControl isDisabled={isError}>
          <FormLabel>Google Analytics (GA4)</FormLabel>
          <Input w="100%" {...register("ga4")} />
        </FormControl>

        <FormControl isDisabled={isError}>
          <FormLabel>LinkedIn Insights</FormLabel>
          <Input w="100%" {...register("insights")} />
        </FormControl>
      </VStack>
    </Section>
  )
}
